import { breakpoints, defaultTheme } from 'gd-design-library';
import { colors } from './colors';

const buttonStyles = {
  background: colors.neutral['grey.10'],
  width: '32px',
  height: '32px',
  minWidth: 'unset',
  borderRadius: '50%',
  padding: '8px',
  svg: {
    width: '12px',
    height: '12px',
  },
};

export const carousel = {
  ...defaultTheme.carousel,
  carouselControls: {
    ...defaultTheme.carousel.carouselControls,
    button: buttonStyles,
  },
  container: {
    ...defaultTheme.carousel.container,
    layout: {
      ...defaultTheme.carousel.container.layout,
      horizontal: {
        ...defaultTheme.carousel.container.layout.horizontal,
        overflowX: 'clip',
        overflowY: 'visible',
        display: 'flex',
        flexDirection: 'column-reverse',
      },
    },
  },
  footer: {
    ...defaultTheme.carousel.footer,
    justifyContent: 'flex-end',
  },
  footerControls: {
    ...defaultTheme.carousel.footerControls,
    display: 'none',
    gap: '0.5rem',
    button: {
      ...buttonStyles,
      '&:disabled + button:disabled': {
        display: 'none',
      },
      '&:disabled:has(+ button:disabled)': {
        display: 'none',
      },
    },
    height: '32px',
    [`@media (min-width: ${breakpoints.md})`]: {
      display: 'flex',
    },
  },
  carouselControlsWrapper: {
    ...defaultTheme.carousel.carouselControlsWrapper,
    default: {
      ...defaultTheme.carousel.carouselControlsWrapper.default,
      maxHeight: '100%',
    },
  },
  contentSlide: {
    ...defaultTheme.carousel.contentSlide,
    paddingLeft: '1rem',
    display: 'flex',
  },
  carouselViewport: {
    ...defaultTheme.carousel.carouselViewport,
    overflow: 'unset',
  },
  carouselDots: {
    ...defaultTheme.carousel.carouselDots,
    gap: '16px',
    justifyContent: 'center',
  },
  carouselDot: {
    ...defaultTheme.carousel.carouselDot,
    default: {
      ...defaultTheme.carousel.carouselDot?.default,
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      backgroundColor: colors.neutral.white,
      opacity: 0.3,
      boxShadow: '1px 1px 2px rgba(0,0,0,.9)',
      border: 'none',
      padding: 0,
      cursor: 'pointer',
      transition: 'opacity 0.25s ease-in',
      '&:hover': {
        opacity: 1,
      },
    },
    active: {
      ...defaultTheme.carousel.carouselDot?.active,
      backgroundColor: colors.neutral.white,
      opacity: 1,
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      boxShadow: '1px 1px 2px rgba(0,0,0,.9)',
      transition: 'opacity 0.25s ease-in',
    },
    nonActive: {
      ...defaultTheme.carousel.carouselDot?.nonActive,
      backgroundColor: colors.neutral.white,
      opacity: 0.3,
    },
  },
};
